import { render, staticRenderFns } from "./MyProjectsList.vue?vue&type=template&id=61eb089f&"
import script from "./MyProjectsList.vue?vue&type=script&lang=js&"
export * from "./MyProjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports